<template>
    <v-container fluid>
        <v-row>
            <sarala-table
                :model="model"
                :resourceName="$tc('resources.customer.name', 1)"
                ref="table"
            >
                <template #deleted_at="{ item }">
                    {{ item.formattedDeletedAt }}
                </template>

                <template #company="{ item }">
                    <template v-if="item.cnpj">
                        <span class="caption">
                            {{ $t('customer.index.table.trade-name') }}:
                        </span>
                        <span class="body-2 font-weight-medium">
                            {{ item.trade_name }}
                        </span>
                        <br />
                        <span class="caption">
                            {{ $t('customer.index.table.legal-name') }}:
                        </span>
                        <span class="body-2">{{ item.legal_name }}</span>
                        <br />
                    </template>

                    <template v-else>
                        <span class="caption">
                            {{ $t('customer.index.table.name') }}:
                        </span>
                        <span class="body-2 font-weight-medium">
                            {{ item.trade_name }}
                        </span>
                        <br />
                    </template>

                    <span class="caption">
                        {{ $t('customer.index.table.document') }}:
                    </span>
                    <span class="body-2">{{ item.document }}</span>
                </template>

                <template #contacts="{ item }">
                    <span class="caption"
                        >{{ $t('customer.index.table.email') }}:
                    </span>
                    <span class="body-2">{{ item.email }}</span
                    ><br />
                    <span class="caption"
                        >{{ $t('customer.index.table.phone') }}:
                    </span>
                    <span class="body-2">{{ item.phone }}</span
                    ><br />
                </template>

                <template #plan="{ item }">
                    <template v-if="item.activePlan">
                        <span class="caption"
                            >{{ $t('customer.index.table.plan') }}:
                        </span>
                        <span class="body-2">{{ item.activePlan.name }}</span
                        ><br />
                        <span class="caption"
                            >{{ $t('customer.index.table.plan-value') }}:
                        </span>
                        <span class="body-2">{{
                            $n(item.activePlan.final_price, 'currency')
                        }}</span
                        ><br />
                    </template>
                </template>

                <template #actionHandler>
                    <CustomerActions
                        ref="actionHandler"
                        @modelChanged="$refs.table.getItems()"
                    />
                </template>
            </sarala-table>
        </v-row>
    </v-container>
</template>

<script>
import CustomerActions from '@/components/actions/customer/CustomerActions'
import Customer from '@/models/Customer'
import SaralaTable from '@/shared/components/SaralaTable'

export default {
    components: {
        CustomerActions,
        SaralaTable,
    },

    computed: {
        model() {
            return new Customer()
        },
    },

    methods: {
        async deleteItem(item) {
            let confirmed = await this.$refs.confirmDelete.confirm(
                item.trade_name,
            )
            if (!confirmed) return

            await item.delete()

            this.$refs.table.getItems()

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.delete', {
                    resource: this.$tc('resources.customer.name', 1),
                }),
            )
        },
    },
}
</script>

<style></style>
